// extracted by mini-css-extract-plugin
module.exports = {"altTextComponent":"utils_altTextComponent__2ofIW","altText":"utils_altText__2ugLT","emptyList":"utils_emptyList__3RC9z"};